<template>
  <div class="mobile-reservation" @scroll="centerScroll($event)" v-if="isMobile">
    <div class="reservation_main">
      <div class="center_top" id="center_top">
        <video class="center_top_video"
          loop="loop"
          autoplay="autoplay"
          playsinline
          webkit-playsinline
          x5-playsinline
          x5-video-player-type="h5"
          :src="reservationVideo"
          :poster="staticUrl+'office/xzdzm/reservation/bg-1.png'"
          muted="muted"
          />
        <div class="center_top_header">
          <img :src="staticUrl+'office/xzdzm/reservation/icon.png'" alt="" class="header_icon"/>
          <div class="header_text">
            <div class="header_text_title">仙宗大掌门</div>
            <div class="header_text_desc">上班打工人，下班当掌门</div>
          </div>
          <div class="header_download" @click="tickDownload"></div>
        </div>
        <div class="center_top_video_circle"></div>
        <div class="center_top_video_btu" @click="tickVideo"></div>
        <div class="center_top_download ani" @click="tickDownload"></div>
      </div>

      <div class="center_yuyue" id="center_yuyue">
        <div class="center_yuyue_title"></div>
        <div class="center_yuyue_desc">当前已有<span>{{ appointNum }}</span>位掌门预约</div>
        <div class="center_yuyue_num">
          <div :class="(appointNum>=50000)?'num1 online':'num1'">5W</div>
          <div :class="(appointNum>=150000)?'num2 online':'num2'">15W</div>
          <div :class="(appointNum>=300000)?'num3 online':'num3'">30W</div>
          <div :class="chongwuType ? ('chongwu '+ chongwuType) :'chongwu'"></div>
          <div :class="(appointNum>=500000)?'num4 online':'num4'">50W</div>
          <div :class="(appointNum>=800000)?'num5 online':'num5'">80W</div>
        </div>
      </div>

      <div class="center_rumen" id="center_rumen">
        <video class="center_rumen_video"
          playsinline
          webkit-playsinline
          x5-playsinline
          x5-video-player-type="h5"
          loop="loop"
          autoplay="autoplay"
          :poster="staticUrl+'office/xzdzm/reservationPc/bg3.png'"
          :src="rmjlVideo"
          muted="muted" />
        <div class="center_rumen_title"></div>
        <div class="center_rumen_desc">
          预约即可获得礼包，游戏公测后统一发放
        </div>
      </div>

      <div class="center_youli" id="center_youli">
        <div class="center_youli_title"></div>
        <div class="center_youli_yaoqing">
          <div class="yaoqing_num">
            <div :class="(this.userInfo.user_id > 0)?'num1 online':'num1'"><span>预约成功</span></div>
            <div :class="(inviteNum >= 1)?'num2 online':'num2'"><span>邀请一位好友</span></div>
            <div :class="(inviteNum >= 2)?'num3 online':'num3'"><span>邀请二位好友</span></div>
            <div :class="(inviteNum >= 3)?'num4 online':'num4'"><span>邀请三位好友</span></div>
            <div :class="(inviteNum >= 4)?'num5 online':'num5'"><span>邀请四位好友</span></div>
            <div :class="(inviteNum >= 5)?'num6 online':'num6'"><span>邀请五位好友</span></div>
            <div :class="(inviteNum >= 6)?'num7 online':'num7'"><span>邀请六位好友</span></div>
          </div>
        </div>
        <div class="center_youli_choujiang">
          <div class="jiangli" @click="tickAwardList"></div>
          <div class="guize" @click="tickAwardRule"></div>
          <div :class="chouJiang.isCircle?'beike circle':'beike'"></div>
          <div class="zhijia"></div>
          <div :class="chouJiang.isSwing?'hand1 swing':'hand1'"></div>
          <div class="jiangpin"></div>
          <!-- <div class="choujiang" @click="tickChouJiang" v-if="chouJiang.sendSec===0"></div>
          <div class="choujiang" v-else></div>
          <div class="yaoqing" @click="tickInviteFriends"></div>
          <div :class="chouJiang.isShowQiu?(chouJiang.qiuClass+' left_shift'):''"></div>
          <div class="inviteNum">当前剩余抽奖次数：{{ lotteryNum }}次</div>
          <div class="friendNum">当前已邀请好友：{{ inviteNum }}人</div> -->
        </div>
      </div>

      <div class="center_images">
        <div class="center_images_juese_title"></div>
        <div class="center_images_juese" id="center_juese">>
          <div class="juese_swiper">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(item,index) in jueseImg" :key="index">
                <img :src="item.image" :alt="item.name">
              </swiper-slide>
            </swiper>
            <div class="juese_swiper_pagination" slot="pagination"></div>
          </div>
        </div>
        <div class="center_images_tese_title"></div>
        <div class="center_images_tese" id="center_tese">
          <div class="tese_swiper">
            <swiper :options="gameSwiperOptions">
              <swiper-slide v-for="(item,index) in teseImg" :key="index">
                <video class="tese_swiper_video"
                  playsinline
                  webkit-playsinline
                  x5-playsinline
                  x5-video-player-type="h5"
                  loop="loop"
                  autoplay="autoplay"
                  :src="item.image"
                  :poster="staticUrl+'office/xzdzm/reservation/img-video.png'"
                  muted="muted" v-if="item.id==='video'" />
                <img :src="item.image" :alt="item.name" v-else>
              </swiper-slide>
            </swiper>
            <div class="tese-swiper-pagination" slot="pagination"></div>
          </div>
        </div>

        <div class="center_images_link">
          <div class="link_items">
            <div class="link_item">
              <a @click="wxToLink">
                <div class="link_item_icon"><img :src="staticUrl+'office/xzdzm/reservation/wechat.png'"/></div>
                <div class="link_item_desc">微信公众号</div>
              </a>
            </div>
            <div class="link_item">
              <a @click="createSuperLabel('sina', downloadUrl.sinaUrl)">
                <div class="link_item_icon"><img :src="staticUrl+'office/xzdzm/reservation/weibo.png'"/></div>
                <div class="link_item_desc">微博</div>
              </a>
            </div>
            <div class="link_item">
              <a @click="createSuperLabel('haoyou', downloadUrl.haoyouUrl)">
                <div class="link_item_icon"><img :src="staticUrl+'office/xzdzm/reservation/haoyou.png'"/></div>
                <div class="link_item_desc">好游快爆</div>
              </a>
            </div>
            <div class="link_item">
              <a @click="createSuperLabel('taptap', downloadUrl.taptapUrl)">
              <div class="link_item_icon"><img :src="staticUrl+'office/xzdzm/reservation/taptap.png'"/></div>
              <div class="link_item_desc">taptap</div>
              </a>
            </div>
          </div>
          <div class="link_button">
            <div class="link_button_text">{{ downloadUrl.qqText }}</div>
            <div class="link_button_link" @click="createSuperLabel('qq', downloadUrl.qqUrl)"></div>
          </div>
        </div>
      </div>
      <div class="center_footbar">
        <img :src="staticUrl+'office/xzdzm/images/zhuzi.png'">
        <img :src="staticUrl+'office/xzdzm/images/12.png'">
        <p>
          <a href="/informationDetail?id=21" target="_blank">隐私政策</a>
          <a href="/informationDetail?id=22" target="_blank">服务条款</a>
        </p>
        <p>公司地址：{{ basicData.address }}</p>
        <p>{{ basicData.copyright }}</p>
        <p v-html="basicData.record_number">{{ basicData.record_number }}</p>
        <p>健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。湿度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
      </div>
    </div>
    <act-login  @onClose='isShowActLogin=false' v-if="isShowActLogin"/>
    <award-success  @onClose='isShowAwardSuccess=false' v-if="isShowAwardSuccess"  :awardId="chouJiang.awardId"/>
    <award-list @onClose='isShowAwardList=false' v-if="isShowAwardList"/>
    <invite-friends  @onClose='isShowInviteFriends=false' v-if="isShowInviteFriends"/>
    <act-success  @onClose='isActSuccess=false' v-if="isActSuccess"/>
    <award-rule  @onClose='isShowAwardRule=false' v-if="isShowAwardRule"/>
    <video-play :src="videoUrl" :controls="isControls" @onClose='isShowVideoPlay=false' v-if="isShowVideoPlay" />
    <wx-link  @onClose='isShowWxLink=false' v-if="isShowWxLink"/>
  </div>
  <div class="pc-reservation" @scroll="centerScroll($event)" v-else>
    <div class="reservation_main">
      <div class="center_top" id="center_top">
        <video class="center_top_video"
          loop="loop"
          autoplay="autoplay"
          playsinline
          webkit-playsinline
          x5-playsinline
          x5-video-player-type="h5"
          :src="reservationPcVideo"
          :poster="staticUrl+'office/xzdzm/reservationPc/bg1.png'"
          muted="muted"
          />
        <div class="center_top_but">
          <div class="video_circle"></div>
          <div class="video_circle2"></div>
          <div class="video_btu" @click="tickVideo"></div>
          <div class="download ani" @click="tickDownload"></div>
        </div>
      </div>

      <div class="center_yuyue" id="center_yuyue">
        <div class="center_yuyue_title"></div>
        <div class="center_yuyue_desc">当前已有<span>{{ appointNum }}</span>位掌门预约</div>
        <div class="center_yuyue_num">
          <div :class="(appointNum>=5)?'num1 online':'num1'">
            <span>5W</span>
            <img :src="staticUrl+'office/xzdzm/reservationPc/jianzhu-15.png'"/>
          </div>
          <div :class="(appointNum>=150000)?'num2 online':'num2'">
            <span>15W</span>
            <img :src="staticUrl+'office/xzdzm/reservationPc/jianzhu-30.png'"/>
          </div>
          <div :class="(appointNum>=300000)?'num3 online':'num3'">
            <span>30W</span>
            <img :src="staticUrl+'office/xzdzm/reservationPc/jianzhu-50.png'"/>
          </div>
          <div :class="chongwuType ? ('chongwu '+ chongwuType) :'chongwu'"></div>
          <div :class="(appointNum>=500000)?'num4 online':'num4'">
            <span>50W</span>
            <img :src="staticUrl+'office/xzdzm/reservationPc/jianzhu-80.png'"/>
          </div>
          <div :class="(appointNum>=800000)?'num5 online':'num5'">
            <span>80W</span>
            <img :src="staticUrl+'office/xzdzm/reservationPc/jianzhu-100.png'"/>
          </div>
        </div>
      </div>

      <div class="center_rumen" id="center_rumen">
        <video class="center_rumen_video"
          playsinline
          webkit-playsinline
          x5-playsinline
          x5-video-player-type="h5"
          loop="loop"
          autoplay="autoplay"
          :poster="staticUrl+'office/xzdzm/reservationPc/bg3.png'"
          :src="rmjlPcVideo"
          muted="muted" />
        <div class="center_rumen_title"></div>
        <!-- <div class="center_rumen_desc">
          预约即可获得礼包，游戏公测后统一发放
        </div> -->
      </div>

      <div class="center_youli" id="center_youli">
        <div class="center_youli_title"></div>
        <div class="center_youli_yaoqing">
          <div class="thread"></div>
          <div class="tree"><img :src="staticUrl+'office/xzdzm/reservationPc/tree.png'"/></div>
          <div class="yaoqing_num">
            <div :class="(this.userInfo.user_id > 0)?'num1 online':'num1'"><span>预约成功</span></div>
            <div :class="(inviteNum >= 1)?'num2 online':'num2'"><span>邀请一位好友</span></div>
            <div :class="(inviteNum >= 2)?'num3 online':'num3'"><span>邀请二位好友</span></div>
            <div :class="(inviteNum >= 3)?'num4 online':'num4'"><span>邀请三位好友</span></div>
            <div :class="(inviteNum >= 4)?'num5 online':'num5'"><span>邀请四位好友</span></div>
            <div :class="(inviteNum >= 5)?'num6 online':'num6'"><span>邀请五位好友</span></div>
            <div :class="(inviteNum >= 6)?'num7 online':'num7'"><span>邀请六位好友</span></div>
          </div>
        </div>
        <div class="center_youli_choujiang">
          <div class="house_bu"></div>
          <div class="house_renwu">
            <video class="house_renwu_video"
              playsinline
              webkit-playsinline
              x5-playsinline
              x5-video-player-type="h5"
              loop="loop"
              autoplay="autoplay"
              :src="choujiangVideo.renwu"
              :poster="staticUrl+'office/xzdzm/reservationPc/choujiang_renwu.png'"
              muted="muted"/>
          </div>
          <div class="house"></div>
          <div class="house_biaoti">
            <video class="house_biaoti_video"
              playsinline
              webkit-playsinline
              x5-playsinline
              x5-video-player-type="h5"
              loop="loop"
              autoplay="autoplay"
              :src="choujiangVideo.title"
              :poster="staticUrl+'office/xzdzm/reservationPc/choujiang_biaoti.png'"
              muted="muted"/>
          </div>
          <div class="jiangli" @click="tickAwardList"></div>
          <div class="guize" @click="tickAwardRule"></div>
          <div :class="chouJiang.isCircle?'beike circle':'beike'"></div>
          <div class="zhijia"></div>
          <div :class="chouJiang.isSwing?'hand1 swing':'hand1'"></div>
          <div class="jiangpin"></div>
          <div class="jieshu"></div>
          <!-- <div class="choujiang" @click="tickChouJiang" v-if="chouJiang.sendSec===0"></div>
          <div class="choujiang" v-else></div>
          <div class="yaoqing" @click="tickInviteFriends"></div>
          <div :class="chouJiang.isShowQiu?(chouJiang.qiuClass+' left_shift'):''"></div>
          <div class="inviteNum">当前剩余抽奖次数：{{ lotteryNum }}次</div>
          <div class="friendNum">当前已邀请好友：{{ inviteNum }}人</div> -->
        </div>
      </div>

      <div class="center_images">
        <div class="center_images_pigeon"></div>
        <div class="center_images_juese_title"></div>
        <div class="center_images_juese" id="center_juese">
          <div class="juese_swiper">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(item,index) in jueseImg" :key="index">
                <img :src="item.image" :alt="item.name">
              </swiper-slide>
            </swiper>
            <div class="juese_swiper_pagination" slot="pagination"></div>
          </div>
        </div>
        <div class="center_images_tese_title"></div>
        <div class="center_images_tese" id="center_tese">
          <div class="tese_swiper">
            <swiper :options="gameSwiperOptions">
              <swiper-slide v-for="(item,index) in teseImg" :key="index">
                <video class="tese_swiper_video"
                  playsinline
                  webkit-playsinline
                  x5-playsinline
                  x5-video-player-type="h5"
                  loop="loop"
                  autoplay="autoplay"
                  :src="item.image"
                  :poster="staticUrl+'office/xzdzm/reservation/img-video.png'"
                  muted="muted" v-if="item.id==='video'" />
                <img :src="item.image" :alt="item.name" v-else>
              </swiper-slide>
            </swiper>
            <div class="tese-swiper-next"></div>
					  <div class="tese-swiper-prev"></div>
            <div class="tese-swiper-pagination" slot="pagination"></div>
          </div>
        </div>
      </div>
      <div class="center_footbar">
        <div class="left">
          <p>
            <img :src="staticUrl+'office/xzdzm/images/zhuzi.png'">
            <img :src="staticUrl+'office/xzdzm/images/12.png'">
          </p>
          <p>
            <a href="/informationDetail?id=21" target="_blank">隐私政策</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a href="/informationDetail?id=22" target="_blank">服务条款</a>
          </p>
        </div>
        <div class="right">
          <p>公司地址：{{ basicData.address }}</p>
          <p>{{ basicData.copyright }}&nbsp;&nbsp; |<span v-html="basicData.record_number">{{ basicData.record_number }}</span></p>
          <p>健康游戏忠告：抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。湿度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
        </div>
      </div>
    </div>
    <div class="reservation_right" :class="{ right_first: 'center_top'=== currentActive }">
      <div class="link_items">
        <div class="link_item qq" @click="createSuperLabel('qq', downloadUrl.qqUrl)">
          <img :src="staticUrl+'office/xzdzm/reservationPc/share-blue-qq.png'"/>
        </div>
        <div class="link_item wechat" @click="wxToLink">
          <img :src="staticUrl+'office/xzdzm/reservationPc/share-blue-wechat.png'"/>
        </div>
        <div class="link_item weibo" @click="createSuperLabel('sina', downloadUrl.sinaUrl)">
          <img :src="staticUrl+'office/xzdzm/reservationPc/share-blue-weibo.png'"/>
        </div>
        <div class="link_item mail">
          <a href="mailto:xzdzm_cs@zhuziplay.com?subject=contact">
            <img :src="staticUrl+'office/xzdzm/reservationPc/share-blue-mail.png'"/>
          </a>
        </div>
        <div class="link_item tap" @click="createSuperLabel('taptap', downloadUrl.taptapUrl)">
          <img :src="staticUrl+'office/xzdzm/reservationPc/share-blue-tap.png'"/>
        </div>
        <div class="link_item bao" @click="createSuperLabel('bao', downloadUrl.haoyouUrl)">
          <img :src="staticUrl+'office/xzdzm/reservationPc/share-blue-bao.png'"/>
        </div>
      </div>
      <div class="menu_items" v-if="'center_top'!== currentActive">
        <div class="menu_item" :class="{ active: 'center_yuyue'=== currentActive }" @click="activeClass('center_yuyue')">预约奖励</div>
        <div class="menu_item" :class="{ active: 'center_rumen'=== currentActive }" @click="activeClass('center_rumen')">入门奖励</div>
        <div class="menu_item" :class="{ active: 'center_youli'=== currentActive }" @click="activeClass('center_youli')">邀请有礼</div>
        <div class="menu_item" :class="{ active: 'center_juese'=== currentActive }" @click="activeClass('center_juese')">弟子名录</div>
        <div class="menu_item" :class="{ active: 'center_tese'=== currentActive }" @click="activeClass('center_tese')">仙门特色</div>
        <div class="menu_top_circle" @click="tickDownload"></div>
        <div class="menu_download ani" @click="tickDownload"></div>
      </div>
    </div>
    <act-login  @onClose='isShowActLogin=false' v-if="isShowActLogin"/>
    <award-success  @onClose='isShowAwardSuccess=false' v-if="isShowAwardSuccess"  :awardId="chouJiang.awardId"/>
    <award-list @onClose='isShowAwardList=false' v-if="isShowAwardList"/>
    <invite-friends  @onClose='isShowInviteFriends=false' v-if="isShowInviteFriends"/>
    <act-success  @onClose='isActSuccess=false' v-if="isActSuccess"/>
    <award-rule  @onClose='isShowAwardRule=false' v-if="isShowAwardRule"/>
    <video-play :src="videoUrl" :controls="isControls" @onClose='isShowVideoPlay=false' v-if="isShowVideoPlay" />
    <wx-link  @onClose='isShowWxLink=false' v-if="isShowWxLink"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { ActLogin, AwardSuccess, AwardList, InviteFriends, ActSuccess, AwardRule, VideoPlay, WxLink } from '@/components'

export default {
  name: 'reservation',
  components: {
    ActLogin,
    AwardSuccess,
    AwardList,
    InviteFriends,
    ActSuccess,
    AwardRule,
    VideoPlay,
    WxLink
  },
  computed: {
    ...mapGetters([
      'downloadUrl',
      'systemOs',
      'appleUrl',
      'isIPhone',
      'awards',
      'gameRolePid',
      'gameImgPid',
      'gameRolePcPid',
      'gameImgPcPid',
      'userInfo',
      'basicData',
      'staticUrl',
      'isAppStore',
      'videoUrl',
      'reservationVideo',
      'reservationPcVideo',
      'rmjlVideo',
      'rmjlPcVideo',
      'xmtsVideo',
      'xmtsPcVideo',
      'choujiangVideo',
      'isMobile',
      'isReservation',
    ])
  },
  data () {
    return {
      currentActive: 'center_top',
      teseImg: [],
      jueseImg: [],
      isControls: true,
      isShowVideoPlay: false,
      chouJiang: {
        isCircle: false,
        isSwing: false,
        isShowQiu: false,
        qiuClass: 'blue',
        sendSec: 0,
        awardId: 0
      },
      isShowActLogin: false,
      isShowAwardList: false,
      isShowAwardRule: false,
      isShowInviteFriends: false,
      isShowAwardSuccess: false,
      isActSuccess: false,
      isShowWxLink: false,
      inviteNum: 0,
      lotteryNum: 0,
      appointNum: 0,
      chongwuType: '',
      swiperOptions: {
        centeredSlides: true,
        spaceBetween : 60,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        loop: true,
        pagination: {
          el: '.juese_swiper_pagination',
          clickable :true,
          renderBullet: function (index, className) {
            return '<div class="' + className + ' img-' + (index+1) + '"></div>';
          },
        }
      },
      gameSwiperOptions: {
        centeredSlides: true,
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: true
        },
        loop: true,
        pagination: {
          el: '.tese-swiper-pagination',
          type: 'bullets',
          clickable: true,
          progressbarOpposite: true,
        },
        navigation: {
          nextEl: '.tese-swiper-next',
          prevEl: '.tese-swiper-prev'
        }
      }
    }
  },
  mounted () {
    document.addEventListener('scroll', this.centerScroll, true)
    this.saveQuery()
    if (this.$route.name === 'reservationSuccess') {
      if (!this.isReservation) {
        this.isShowActLogin = true
      } else {
        this.isActSuccess = true
      }
    } else if (this.$route.name === 'reservationAwards') {
      if (!this.isReservation) {
        this.isShowActLogin = true
      } else {
        this.isShowAwardList = true
      }
    }
    if (this.isReservation) {
      this.loadInviteNum()
    }
    this.loadData()
  },
  created () {
    this.getGamesImg()
    this.getGamesRoleImg()
    document.addEventListener("WeixinJSBridgeReady", function () {
      document.querySelector('.center_top_video').play();
      document.querySelector('.center_rumen_video').play();
      document.querySelector('.choujiang_video').play();
      document.querySelector('.tese_swiper_video').play();
    }, false);
    console.log(this.userInfo)
  },
  methods: {
    ...mapActions(['getBannerList','ActReservation', 'ActAppointNum', 'ActInviteNum', 'ActCodeList', 'ActLottery', 'ActSetInvite']),
    saveQuery () {
      if (typeof (this.$route.query) !== 'undefined') {
        if (typeof (this.$route.query['fromuid']) !== 'undefined') {
          this.ActSetInvite({ invite_uid: parseInt(this.$route.query['fromuid']) })
        } else {
          this.ActSetInvite({ invite_uid: 0 })
        }
      }
    },
    tickVideo () {
      this.isShowVideoPlay = true
    },
    tickDownload () {
      this.$router.push({ name: 'download', query: { download: this.systemOs }})
    },
    tickBook () {
      // if (typeof (this.isIPhone) !== 'undefined' && this.isIPhone) {
      //   this.createSuperLabel('apple', this.appleUrl)
      // } else {
        if (!this.isReservation) {
          this.isShowActLogin = true
        } else {
          this.showError('您已经成功预约过，邀请好友即可获得机会！')
          this.isShowActLogin = true
        }
      // }
    },
    tickAwardList () {
      if (!this.isReservation) {
        // this.showError('请先预约才会有奖励哦！')
        this.showError('请先登录才能看预约奖励哦！')
        this.isShowActLogin = true
        return false
      } else {
        this.isShowAwardList = true
      }
    },
    tickAwardRule () {
      this.isShowAwardRule = true
    },
    tickChouJiang () {
      this.chouJiang.sendSec = 6
      let timeSec = setInterval(() => {
        this.chouJiang.sendSec--
        if (this.chouJiang.sendSec <= 0) {
          this.chouJiang.sendSec = 0
          clearInterval(timeSec)
        }
      }, 500)

      if (!this.isReservation){
        this.showError('请先预约才会有奖励哦！')
        this.isShowActLogin = true
        return false
      }
      // if (this.lotteryNum > 6) {
      //   this.showError('您的抽奖次数已达上限！')
      //   return false
      // }
      if (this.lotteryNum === 0) {
        this.showError('您目前抽奖次数是0，邀请好友即可获得机会！')
        return false
      }
      this.chouJiang.isSwing = true
      let timeId = setInterval(() => {
        this.chouJiang.isCircle = true
        clearInterval(timeId)
      }, 500)
      this.ActLottery().then(res => {
        if (res.code === 1) {
          this.showError(res.msg)
          return false
        }
        this.chouJiang.awardId = res.id
        this.chouJiang.qiuClass = ''
        if (this.chouJiang.awardId > 0) {
          var index = this.awards.findIndex(item => {
            if (item.id === this.chouJiang.awardId) {
              this.chouJiang.qiuClass = item.ball
            }
          })
        }
      })

      if (this.chouJiang.awardId > 0) {
        let timeId2 = setInterval(() => {
          this.chouJiang.isShowQiu = true
          clearInterval(timeId2)
        }, 1000)

        let timeId3 = setInterval(() => {
          this.isShowAwardSuccess = true
          clearInterval(timeId3)
        }, 2000)
        this.loadInviteNum()
      }

      let timeId4 = setInterval(() => {
        this.chouJiang.isSwing = false
        this.chouJiang.isCircle = false
        this.chouJiang.isShowQiu = false
        clearInterval(timeId4)
      }, 3000)
    },
    tickInviteFriends () {
      if (!this.isReservation) {
        this.showError('请先预约获取分享地址！')
        this.isShowActLogin = true
        return false
      } else {
        this.isShowInviteFriends = true
      }
    },
    loadData () {
      this.ActAppointNum().then(res => {
        this.appointNum = parseInt(res.count * 11 + 880000)
        if(this.appointNum>=50000) {
          this.chongwuType = 'run1'
        } else if(this.appointNum>=150000) {
          this.chongwuType = 'run2'
        } else if(this.appointNum>=300000) {
          this.chongwuType = 'run3'
        } else if(this.appointNum>=500000) {
          this.chongwuType = 'run4'
        } else if(this.appointNum>=800000) {
          this.chongwuType = 'run5'
        }

      })
    },
    loadInviteNum () {
      if (this.userInfo.token === '') {
        return false
      }
      this.ActInviteNum().then(res => {
        this.inviteNum = res.invite_num
        this.lotteryNum = res.lottery_num
      })
    },
    showAwardList () {
      if (this.userInfo.token === '' && !this.isReservation) {
        this.isShowAwardList = false
      } else {
        this.isShowAwardList = true
      }
    },
    wxToLink () {
      this.isShowWxLink = true
    },
    createSuperLabel (id, url) {
      let a = document.createElement('a');
      a.setAttribute('href', url);
      a.setAttribute('target', '_blank');
      a.setAttribute('id', id);
      if (!document.getElementById(id)) {
        document.body.appendChild(a);
      }
      a.click();
    },
    getGamesRoleImg () {
      let position_id = this.gameRolePcPid
      if (this.isMobile) {
        position_id = this.gameRolePid
      }
      this.getBannerList({ position_id: position_id, status: 1 }).then(res => {
        this.jueseImg = res.list
      }).catch(() => {
        this.showError('您的请求参数错误！')
      })
    },
    getGamesImg () {
      let position_id = this.gameImgPcPid
      let  xmtsVideo = this.xmtsPcVideo
      if (this.isMobile) {
        position_id = this.gameImgPid
        xmtsVideo = this.xmtsVideo
      }
      this.getBannerList({ position_id: position_id, status: 1 }).then(res => {
        res.list.push({image: xmtsVideo, title: '视频', id: 'video'})
        this.teseImg = res.list
      }).catch(() => {
        this.showError('您的请求参数错误！')
      })
    },
    centerScroll () {
      var scrollVals = [{ top: 0, id: 'center_top' }, { top: 100, id: 'center_yuyue' }, { top: 200, id: 'center_rumen' }, { top: 300, id: 'center_youli' }, { top: 400, id: 'center_juese' }, { top: 500, id: 'center_tese' }];
      scrollVals[0].top = document.querySelector('#center_top').getBoundingClientRect().top
      scrollVals[1].top = document.querySelector('#center_yuyue').getBoundingClientRect().top
      scrollVals[2].top = document.querySelector('#center_rumen').getBoundingClientRect().top
      scrollVals[3].top = document.querySelector('#center_youli').getBoundingClientRect().top
      scrollVals[4].top = document.querySelector('#center_juese').getBoundingClientRect().top
      scrollVals[5].top = document.querySelector('#center_tese').getBoundingClientRect().top
      let minTopArr = this.topSort(scrollVals, 'top')
      if (this.currentActive !== minTopArr[0].id) {
        this.currentActive = minTopArr[0].id
      }
    },
    topSort (objArr, key) {
      let result = objArr.slice(0);
      return result.sort((a, b) => Math.abs(a[key]) - Math.abs(b[key]));
    },
    activeClass (index) {
      this.currentActive = index
      document.querySelector('#' + index).scrollIntoView(
        { behavior: 'smooth' }
      )
    },
  }
};
</script>
<style lang="scss">
  @import '@/assets/mobile/reservation.scss';
  @import "@/assets/styles/reservationNew.scss";
</style>
